import React, {useState} from 'react'
import s from './header.module.css'
import {useLocation} from 'react-router-dom'
import {Col, Dropdown, Layout, Menu, Row} from 'antd'
import {useDispatch, useSelector} from 'react-redux'
import {AppStateType} from '../../store'
import MenuDrawer from './MenuDrawer'
import {Account, MenuIcon} from './SVGS'
import {actions} from "../../store/actions/user";
import './style.css'
import {useTranslation} from "react-i18next";
import Lang from "./Lang";
//import {MenuFoldOutlined, MenuUnfoldOutlined} from '@ant-design/icons'
import {SearchOutlined} from "@ant-design/icons/lib";
import {getActualPayment} from "../../containers/Pay/store/actions";
import CheckPay from "../../containers/Pay/CheckPay";
import authApi from "../../api/user";

const linkItems = [
    '/about',
    '/help',
    '/contacts'
]

export const Header: React.FC = (props) => {

    const { isAuth, username } = useSelector((state: AppStateType ) => state.userReducer)
    const {isAsked} = useSelector((state: AppStateType) => state.payment)
    const {t} = useTranslation(['resources', 'translation'])
    const location = useLocation();
    const { pathname } = location;
    const dispatch = useDispatch()
    const [openCheck, setOpenCheck] = React.useState(false);
    const [serVisible, setSerVisible] = useState(false);
    const { Header } = Layout;

    const toggleCollapsed = () => {
        setSerVisible( !serVisible );
    };

    const handleLogOut = () => {
        authApi.logout()
            .then(response => {
                if (response.code === 200) { }
            })
            .catch(err => {})
            .finally(()=>{
                dispatch(actions.clearAuthUserData())
                window.location.href = '/'
            })
    }

    const handleOpenDialog = () => {
        if(!isAsked && isAuth) {
            dispatch(getActualPayment())
        }
        setOpenCheck(true)
    };

    const menu = (
        <Menu>
            {
                pathname !== '/account' ?
                <Menu.Item key="account" className={s.menuItem}>
                    <a href="/home/cabinet">
                        {t('PersonalCabinet')}
                    </a>
                </Menu.Item> : null
            }
            <Menu.Item key="logout" className={s.menuItem} onClick={handleLogOut}>
                {t('LogOut')}
            </Menu.Item>
        </Menu>
    )

    return <Header className="header">
        <Row style={{ width: "100%", height: "100%", alignItems: 'center' }}>
            <Col xs={18} sm={18} md={14} lg={14} xl={14}>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <span className='logoIcon' onClick={toggleCollapsed}>
                        {/*{React.createElement(!serVisible ? MenuUnfoldOutlined : MenuFoldOutlined)}*/}
                        {MenuIcon}
                    </span>
                <a href ="/" className="logo">
                    {t('PledgedMovableEstateRegister')}
                    {/*<div className={s.logoName}>{t('title')}</div>*/}
                </a>
                </div>
            </Col>
            <Col xs={6} sm={6} md={7} lg={7} xl={5}>
                <div>
                    <Menu
                          mode="horizontal"
                          selectedKeys={[pathname]}
                          className={'middleMenu'}
                    >
                        <Menu.Item key='/search' onClick={handleOpenDialog} style={{color: 'inherit'}}>
                            <SearchOutlined />
                            <span className='mdHide' style={{marginLeft: 7}}>{t('translation:Search')}</span>
                        </Menu.Item>
                        <Menu.Item key='/lang'><Lang /></Menu.Item>
                    </Menu>
                </div>
            </Col>
            <Col xs={0} sm={0} md={3} lg={3} xl={5}>
                <div className='login' style={{display: 'flex', justifyContent:'flex-end'}}>
                    { isAuth ? (
                        <div>
                            <Menu
                                // style={{minWidth:"100%"}}
                                disabledOverflow
                                id="rHeadMenu"
                                mode="horizontal"
                                selectable={ false }
                            >
                                <Menu.Item key='user'>
                                    <Dropdown
                                        className={s.subMenu}
                                        overlay={menu}
                                        placement="bottomRight">
                                        <div className='account-icon'>
                                            <span className='xlHide'> {username}</span>
                                            <span style={{display:'flex', paddingLeft: 3}}>{Account}</span>
                                        </div>
                                    </Dropdown>
                                </Menu.Item>
                            </Menu>
                        </div>)
                    : pathname !== '/login' ? <a href={'/account/login'}>{t('LogIn')}</a> : null
                    }
                </div>
            </Col>
        </Row>
        <CheckPay open={openCheck} setOpen={setOpenCheck} isAuth={isAuth}/>
        <MenuDrawer
            visible={serVisible}
            setVisible={(visible: boolean) => setSerVisible(visible)}
        />
    </Header>
}
